import React from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './styles.scss'

const ReassuranceSlider = ({ contents }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
  }

  return (
    <div className='reassurance-slider'>
      <Slider {...settings}>
        {contents.map((slide, i) =>
          <div className='reassurance-slide' key={i}>
            {slide.img && <div className='reassurance-slide-img'><img src={slide.img} /></div>}
            <div>
              <p className='text-bold'>{slide.title}</p>
              <p>{slide.text}</p>
            </div>
          </div>
        )}
      </Slider>
    </div>
  )
}

export default ReassuranceSlider
